const notificationsTypes = {
  PRIVATE_EVENT: "private_event",
  FOR_YOU: "for_you_activity",
  NOT_FOR_YOU: "not_for_you_activity",
  PREVIEW_MONTAGE_ERROR: "preview_montage_error",
  PREVIEW_MONTAGE_DONE: "preview_montage_done",
  TRIM_VIDEO_ERROR: "trim_video_error",
  TRIM_VIDEO_DONE: "trim_video_done",
  TRANSCRIPTION_ERROR: "transcription_error",
  TRANSCRIPTION_DONE: "transcription_done",
  CLUBS_ALIGNED: "clubs_aligned",
  PROGRAMS_ALIGNED: "programs_aligned",
  CHANGE_TENANT: "change_tenant",
  VIDEO_STORY_UPDATED: "video_story_updated"
};

export default notificationsTypes;
